import { CORE, gateway } from '../../api';

export function getTiposIntervaloPagamentoService() {
  return gateway.get(`${CORE}/tipo-intervalo-pagamento`);
}
